export const scaleThreshold = ({ domain, range }) => {
  return (value) => {
    const index = domain.findIndex((threshold) => value < threshold);
    return index === -1 ? range[range.length - 1] : range[index];
  };
};
